import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Col, Container, Row, Input, Label } from "reactstrap";

import contactImage from "../../assets/images/contact.png";
import { get, post } from "../../utils/apiUtil";

const ContactContent = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        comments: ''

    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const submitContactForm = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const response = await post('/send-details', formData);
            alert("Your details has been forwarded to concerend department.");
        } catch (error) {
            alert(error?.message || "Something went wrong.");
        } finally {
            setIsLoading(false);
        }
        console.log(formData);
    }

    return (
        <React.Fragment>
            <section className="section">
                <Container>
                    <Row className="align-items-center mt-5">
                        <Col lg={6}>
                            <div className="section-title mt-4 mt-lg-0">
                                <h3 className="title">Get in touch</h3>
                                <p className="text-muted mt-3">
                                    Have questions or need assistance? Our team is here to help. Whether you're a job seeker or an employer, feel free to reach out—we're just a message away and ready to support your journey.
                                </p>
                                <Form
                                    method="post"
                                    className="contact-form mt-4"
                                    name="myForm"
                                    id="myForm"
                                    onSubmit={submitContactForm}
                                >
                                    <span id="error-msg"></span>
                                    <Row>
                                        <Col lg={12}>
                                            <div className="form-floating mb-3">
                                                <Input
                                                    type="text"
                                                    name="name"
                                                    id="nameInput"
                                                    className="form-control"
                                                    placeholder="Enter your name"
                                                    onChange={handleInputChange}
                                                />
                                                <Label htmlFor="nameInput">Name</Label>
                                            </div>
                                        </Col>

                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    id="emailInput"
                                                    className="form-control"
                                                    placeholder="Enter your email"
                                                    onChange={handleInputChange}
                                                />
                                                <Label htmlFor="emailInput">Email</Label>
                                            </div>
                                        </Col>

                                        <Col md={6}>
                                            <div className="form-floating mb-3">
                                                <Input
                                                    type="text"
                                                    name="subject"
                                                    id="subjectInput"
                                                    className="form-control"
                                                    placeholder="Enter your subject"
                                                    onChange={handleInputChange}
                                                />
                                                <Label htmlFor="subjectInput">Subject</Label>
                                            </div>
                                        </Col>

                                        <Col lg={12}>
                                            <div className="form-floating mb-3">
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Enter your message"
                                                    id="messageInput"
                                                    name="comments"
                                                    rows="3"
                                                    style={{ height: '120px' }}
                                                    onChange={handleInputChange}
                                                ></textarea>
                                                <Label htmlFor="messageInput">Your Message</Label>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className="text-end">
                                        <button
                                            type="submit"
                                            id="submit"
                                            name="submit"
                                            className="btn btn-primary"
                                            disabled={isLoading}
                                        >
                                            {" "}
                                            {isLoading ? 'Please wait' : 'Send Message'} <i className="uil uil-message ms-1"></i>
                                        </button>
                                    </div>
                                </Form>
                            </div>
                        </Col>
                        <Col lg={5} className="ms-auto order-first order-lg-last">
                            <div className="text-center">
                                <img src={contactImage} alt="" className="img-fluid" draggable={false} />
                            </div>
                            <div className="mt-4 pt-3">
                                <div className="d-flex text-muted align-items-center mt-2">
                                    <div className="flex-shrink-0 fs-22 text-primary">
                                        <i className="uil uil-map-marker"></i>
                                    </div>
                                    <div className="flex-grow-1 ms-2">
                                        <p className="mb-0">
                                            7574 Woodmere Ct Suite #100, Liberty Twp, OH 45044
                                        </p>
                                    </div>
                                </div>
                                <div className="d-flex text-muted align-items-center mt-2">
                                    <div className="flex-shrink-0 fs-22 text-primary">
                                        <i className="uil uil-envelope"></i>
                                    </div>
                                    <div className="flex-grow-1 ms-2">
                                        <p className="mb-0">info@matrixexecutivesearch.com</p>
                                    </div>
                                </div>
                                <div className="d-flex text-muted align-items-center mt-2">
                                    <div className="flex-shrink-0 fs-22 text-primary">
                                        <i className="uil uil-phone-alt"></i>
                                    </div>
                                    <div className="flex-grow-1 ms-2">
                                        <p className="mb-0">+1 (513) 777-0550</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <div className="map">
                <iframe
                    title="maps"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3082.303987210627!2d-84.3729415!3d39.417249899999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88405beb7a1cd085%3A0xf9db84fc7ad01764!2s7574%20Woodmere%20Ct%20%23100%2C%20Liberty%20Township%2C%20OH%2045044%2C%20USA!5e0!3m2!1sen!2s!4v1753124094224!5m2!1sen!2s"
                    height="350"
                    style={{ border: `0`, width: `100%` }}
                    allowFullScreen=""
                    loading="lazy"
                ></iframe>
            </div>
        </React.Fragment>
    );
};

export default ContactContent;
